import { useFetch } from "@hooks/useFetch";
import { getDevicesApiRoute } from "@api-routes/eirSalesFacade";
import { useEffect, useState } from "react";
import { IDevicesResponse } from "@features/cart/interfaces/IDeviceDetails";

export const useGetDeviceList = () => {
    const [getDeviceListState, { get }] = useFetch();
    const [deviceList, setDeviceList] = useState<IDevicesResponse>();

    useEffect(() => {
        get<IDevicesResponse | undefined>(getDevicesApiRoute()).then((devices) => {
            if (devices) {
                setDeviceList(devices);
            }
        });
    }, [get]);

    return { deviceList, getDeviceListState };
};
